import React from 'react';
import './SelectSearch.scss';
import SelectSearchComp, { components as selectComponents } from 'react-select';
import SelectSearchDropSvg from './SelectSearchDropSvg';

export const getValue = (options, checkValue) => {
  if (!options || !checkValue) {
    return null;
  }
  const obj = options.filter((option) => option.value === checkValue);
  return obj;
};

export const getOptions = (arr) => {
  if (!arr) return [];

  const options = arr.map(({ name, id }) => ({ label: name, value: id }));
  return options;
};

const SelectSearch = ({
  options,
  label,
  name,
  onChange,
  classes,
  value,
  placeholder,
  hideLabel,
  required,
  disabled,
  isRequired,
  inputWrapperClass,
  fullWidth,
}: any) => {
  const DropdownIndicator = (props: any) => (
    <selectComponents.DropdownIndicator {...props}>
      <SelectSearchDropSvg disabled={props.isDisabled} />
    </selectComponents.DropdownIndicator>
  );
  // const [isClicked, setIsClicked] = useState(false);
  const handleChange = (e: any) => {
    onChange({ target: { value: e.value, name, id: e.id } });
  };
  const valueResult = getValue(options, value);
  // zIndex: isClicked ? '' : '2'
  return (
    <div
      style={{ height: '50px' }}
      className={`${valueResult ? 'select-search-with-value' : 'select-wrap'} select-custom-styles${fullWidth ? ' select-search--full-width' : ''}`}
    // onMouseEnter={() => setIsClicked(true)}
    >
      {!hideLabel && (
        <span className="label-name">
          {label}
        </span>
      )}
      <div className={`select-search ${classes || ''} `}>
        <span>{placeholder}</span>
        <div className={`select-input-wrapper ${inputWrapperClass || ''} `}>

          {/* <div className="drop-down-select-search">
            <SelectSearchDropSvg disabled={disabled} />
          </div> */}
          <SelectSearchComp
            placeholder={(
              <div>
                {placeholder}
                {
                  isRequired && <sup style={{ color: 'rgba(248, 20, 20, 1)', fontSize: '12px', marginLeft: '2px' }}>*</sup>
                }

              </div>
            )}
            onChange={handleChange}
            className={`basic-single ${placeholder && valueResult && 'input_select_with_value'} ${disabled && 'disabled-select'}`}
            value={valueResult}
            options={options}
            required={required}
            isDisabled={disabled}
            components={{ DropdownIndicator }}
            styles={{
              control: (base: any) => ({
                ...base,
                border: '1px solid #eaecf0b2',
                // This line disable the blue border
                boxShadow: 'none',
                height: '52px',
                color: 'black',
                paddingTop: value ? '16px' : '0px',
                background: disabled ? 'rgba(245,245,245, 0.7)' : 'rgba(255, 255, 255, 0.1)',
                paddingLeft: '5px',
                fontSize: '12px',
                // This line disable the outline border
                '&:hover': {
                  boxShadow: 'none',
                },
                '&:focus': {
                  boxShadow: 'none',
                },
              }),
              indicatorSeparator: (base: any) => ({
                ...base,
                display: 'none',
              }),
              singleValue: (base: any) => ({
                ...base,
                color: '#000000',
                fontSize: '12px',
                fontWeight: '400',
              }),
              option: (base: any, state: any) => ({
                ...base,
                color: state?.isSelected ? 'black' : '#000000',
                backgroundColor: state?.isSelected ? 'rgba(89, 65, 169, 0.10)' : '#fff',
                fontSize: '13px',
                lineHeight: '24px',
                fontWeight: '400',

                zIndex: 5000,
                '&:hover': {
                  backgroundColor: state?.isSelected ? 'rgba(89, 65, 169, 0.10)' : '#F5F5F5',
                  cursor: 'pointer',
                },
              }),
              menu: (base: any) => ({
                ...base,
                zIndex: 7000,
              }),
              placeholder: (base: any) => ({
                ...base,
                fontSize: '12px',
                lineHeight: '24px',
                fontWeight: '400',
                color: '#999999',
              }),
              dropdownIndicator: (base: any) => ({
                ...base,
                opacity: disabled ? '0' : '1',
                paddingRight: '10px',
                paddingLeft: '4px',
              }),
            }}

          />

        </div>

      </div>
    </div>
  );
};

export default SelectSearch;
